module.exports = "textarea {\n    resize: none;\n}\n\n.btn.patentPaymentOption {\n    margin-top: 22px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\nh3.titleUploader {\n    margin-top: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patentPayment/patentPayment.editor.component.css
 ** module id = 1098
 ** module chunks = 0
 **/